<section class="request" *ngIf="bookingData">
  <h5 class="request--title">{{ 'bookingData' | i18next }}</h5>
  <div class="bookingData">
    <div class="rowInfo">
      <p class="label">
        {{ 'forWhom' | i18next }}
      </p>
      <p class="text">
        {{ translate.translateForWhom(bookingData.customerType) }}
      </p>
    </div>
    <div class="rowInfo">
      <p class="label">
        {{ 'name' | i18next }}
      </p>
      <p class="text">{{ bookingData.firstName }}</p>
    </div>
    <div class="rowInfo">
      <p class="label">
        {{ 'firstSurname' | i18next }}
      </p>
      <p class="text">{{ bookingData.firstLastName }}</p>
    </div>
    <div class="rowInfo">
      <p class="label">{{ 'secondSurname' | i18next }}</p>
      <p class="text">{{ bookingData.secondLastName }}</p>
    </div>
    <div class="rowInfo">
      <p class="label">{{ 'phone' | i18next }}</p>
      <p class="text">{{ bookingData.phone }}</p>
    </div>
    <div class="rowInfo">
      <p class="label">{{ 'email' | i18next }}</p>
      <p class="text">{{ bookingData.email }}</p>
    </div>
    <div class="rowInfo">
      <p class="label">{{ 'observations' | i18next }}</p>
      <p class="text">
        {{ bookingData.observations ? bookingData.observations : noComments }}
      </p>
    </div>
  </div>
</section>
